import { SVGProps } from 'react';

export const FilterResetIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.99979 12.25C9.89931 12.25 12.2498 9.89952 12.2498 7C12.2498 4.10051 9.89931 1.75 6.99979 1.75C5.05655 1.75 3.3599 2.80577 2.45215 4.375"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.75 1.75V2.49559C1.75 3.77419 1.75 4.41349 2.16256 4.76299C2.57513 5.11248 3.20573 5.00738 4.46693 4.79718L5.25 4.66667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
